import * as React from "react";
import { Outlet } from "react-router-dom";
import { PatientNavigation } from "./PatientNavigation";
import { LastTriageData } from "./LastTriageData";
import { useAuth } from "@/hooks/useAuth";
import { cn } from "@/lib/utils";



interface PatientLayoutProps {
  className?: string;
  showSidebar?: boolean;
  showLastTriage?: boolean;
}

export function PatientLayout({ 
  className,
  showSidebar = true, // Controls visibility of the desktop sidebar with LastTriageData
  showLastTriage = true // Controls visibility of the mobile LastTriageData in PatientNavigation
}: PatientLayoutProps) {
  const { profile } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Top navigation: includes breadcrumbs, nav tabs, user menu, and mobile LastTriageData */}
      <PatientNavigation 
        showLastTriage={showLastTriage} // This prop controls the mobile-only LastTriageData in PatientNavigation
      />
      
      <div className="flex flex-1 overflow-hidden">
        {/* Desktop Sidebar: Contains the primary LastTriageData for larger screens */}
        {showSidebar && (
          <aside className="hidden lg:block w-64 border-r bg-white p-4">
            <LastTriageData 
              variant="sidebar"
              showTriageButton={true}
            />
          </aside>
        )}
        
        {/* Main content area */}
        <main className={cn(
          "flex-1 overflow-y-auto p-6",
          className
        )}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
